import React from 'react';
import { useTranslation } from 'react-i18next';
import './FarmCard.css';

export default function FarmCard({ farm, onEdit, onDelete }) {
  const { t } = useTranslation();
  const f = farm;

  return (
    <div className="farm-card bmp-card">
      <div className="farm-card-top">
        <strong className="farm-card-name">{f.name}</strong>
        <span className={`bmp-tag bmp-zone--${f.zone}`}>{f.zone_display}</span>
      </div>
      {f.city && <span className="farm-card-city">{f.city}</span>}
      <div className="farm-card-meta">
        {f.hectares && <span>{f.hectares} ha</span>}
        <span className="bmp-tag">{f.fruit_type_display}</span>
      </div>
      {f.certifications && <p className="farm-card-certs">{f.certifications}</p>}
      <div className="farm-card-actions">
        <button className="bmp-btn bmp-btn-secondary" onClick={onEdit}>{t('wc_edit')}</button>
        <button className="bmp-btn bmp-btn-danger" onClick={onDelete}>{t('wc_delete')}</button>
      </div>
    </div>
  );
}
